module.exports = __webpack_public_path__ + "img/request_transfer_icon.cd70885c.svg";